import MobileConsentSolutionsList from './mobile-consent-solutions-list';
import manageAccess from './manageAccess';
import MobileConsentSolutionsCreate from './mobile-consent-solutions-create';
import MobileConsentSolutionsEdit from './mobile-consent-solutions-edit';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  list: manageAccess(MobileConsentSolutionsList),
  create: manageAccess(MobileConsentSolutionsCreate),
  edit: manageAccess(MobileConsentSolutionsEdit),
};
